import { type ComponentsOverrides, type Theme } from '@mui/material/styles'

export const overridesFormLabel = (theme: Theme): ComponentsOverrides['MuiFormLabel'] => ({
  root: {
    color: theme.palette.text.primary,
  },
})
